<template>
    <v-autocomplete
            :items="students"
            :search-input.sync="searchQuery"
            :loading="isLoading"
            label="Pick a student"
            item-value="value"
            item-text="text"
            v-model="selectedStudentId"
            clearable
            clear-icon="close"
            prepend-inner-icon="face"
            @input="onInputChanged()"
    ></v-autocomplete>
</template>

<script>
    import {UrlUtils} from '../utils/UrlUtils'
    import {Student} from "../state/models/Student";

    export default {
        name: "StudentPickerAutocomplete",
        props: {
            useQueryString: false
        },
        data: function() {
            return {
                students: [],
                selectedStudentId: null,
                searchQuery: null,
                isLoading: false
            };
        },
        methods: {
            onInputChanged() {
                this.updateQueryStringIfOn();
                this.$emit('input', this.selectedStudentId);
            },
            updateQueryStringIfOn() {
                if (this.useQueryString) {
                    UrlUtils.updateQueryStringParam('studentId', this.selectedStudentId);
                }
            },
        },
        watch: {
            search (val) {
                // Items have already been loaded
                if (this.students.length > 0) {
                    return;
                }

                // Items have already been requested
                if (this.isLoading) {
                    return;
                }

                this.isLoading = true;

                this.$store.dispatch('searchStudents', {searchQ: val})
                    .then((sList) => {
                        this.students = sList;
                    })
                    .finally(() => (this.isLoading = false))
            }
        },
        mounted() {
            this.$store.dispatch('getStudents')
                .then((sList) => {
                    if (!sList || !sList.length) {
                        return Promise.reject('Students were not found');
                    }
                    this.students = sList.map(s => {return {value: s.id, text: s.getFullName()}});

                    if (this.useQueryString) {
                        // check if there is a student id on the query string
                        let studentIdFromQuery = +this.$router.currentRoute.query['studentId'];
                        if (studentIdFromQuery) {
                            this.selectedStudentId = studentIdFromQuery;
                        }
                    }
                });
        }
    }
</script>

<style scoped>

</style>
